import { useEffect, useRef, useState } from "react";
import { useInView } from "framer-motion";

export default function AnimatedUnderline({
  children,
  as: Tag = "span",
  className = "",
  delay = 0,
  inner = false,
  ...props
}) {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.2 });
  const [active, setActive] = useState(false);

  useEffect(() => {
    if (!isInView) return;
    if (delay > 0) {
      const t = setTimeout(() => setActive(true), delay * 1000);
      return () => clearTimeout(t);
    }
    setActive(true);
  }, [isInView, delay]);

  return (
    <Tag
      ref={ref}
      className={[
        "underlineReveal",
        active ? "urActive" : "",
        inner ? "urInner" : "",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
      {...props}
    >
      {children}
    </Tag>
  );
}
